import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { stringify } from 'qs';
import keys from 'lodash/keys';
import * as TYPES from './types';
import { extractProductReference } from '~/helpers/extract-helper';
import { fetchProduct, fetchProductCarousels } from '~/services/product';
export default {
  fetchProductCarousels(_ref, _ref2) {
    var _this = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;
      let {
        alias,
        profileId,
        exclude,
        useLatest
      } = _ref2;
      const reference = extractProductReference(alias);
      const product = yield fetchProductCarousels(_this, reference, profileId, exclude, useLatest);
      commit(TYPES.SET_PRODUCT_CAROUSELS, product);
    })();
  },

  fetchProduct(_ref3, _ref4) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref3;
      let {
        alias,
        query,
        profileId,
        useLatest
      } = _ref4;
      const reference = extractProductReference(alias);
      const product = yield fetchProduct(_this2, reference, query.offer, profileId, useLatest);
      const {
        currentLocale
      } = _this2.state.i18n;
      const currentQuery = keys(query).length ? "?".concat(stringify(query)) : '';
      const currentAlias = "".concat(product.slug, "-").concat(product.reference, ".htm");

      if (alias !== currentAlias && process.server) {
        _this2.app.context.redirect(301, "/".concat(currentLocale.market, "/").concat(currentLocale.language, "/p/").concat(currentAlias).concat(currentQuery));
      }

      if (product && product.redirect_url) {
        if (process.server && product.redirect_url) {
          _this2.app.context.redirect(301, "".concat(product.redirect_url).concat(currentQuery));
        } else {
          window.location.href = "".concat(product.redirect_url).concat(currentQuery);
        }
      }

      commit(TYPES.SET_PRODUCT, product);
    })();
  }

};